import React from "react";
import styled from "styled-components";
import Authorization from "../components/layout/Authorization";
import Feedback from "../components/layout/feedback/Feedback";
import InvisibleForm from "../components/layout/feedback/InvisibleForm";
import Navbar from "../components/Navigation";
import GetUrl from "../components/layout/GetUrl";
import Title from "../components/layout/Title";
import colors from "../styles/colors";
import fonts from "../styles/fonts";
import "./index.css";

const Wrapper = styled.div`
  color: ${colors.header};
`;

const Header = styled.div`
  background: white;
  border-bottom: solid 1px ${colors.border};
  display: flex;
  flex-direction: row;
  height: 75px;
  align-items: center;
  padding: 0 8.334%;
`;

const Main = styled.div`
  background: white;
  border: 1px solid ${colors.border};
  color: ${colors.main};
  font-family: ${fonts.main};
  margin: 4.5em auto;
  max-width: 800px;
  width: 83%;

  @media screen and (max-width: 750px) {
    margin: 8.5% auto;
  }

  h1 {
    font-family: ${fonts.header};
    font-size: 2.25em;
    font-weight: 600;
    letter-spacing: 1px;
    margin-bottom: 1.2em;
    text-align: center;
    text-transform: uppercase;
  }

  h2 {
    color: ${colors.accent};
    font-family: ${fonts.header};
    font-size: 1.2em;
    font-weight: 900;
    letter-spacing: 0.04em;
    margin-bottom: 0.4em;
    text-transform: uppercase;
  }

  h3 {
    color: ${colors.accent};
    font-family: ${fonts.header};
    font-size: 1.1em;
    font-weight: 500;
    letter-spacing: 0.04em;
    margin-bottom: 0.2em;
    margin-top: -0.1em;
    text-transform: uppercase;
  }

  h4 {
    color: ${colors.accent};
    font-family: ${fonts.header};
    font-size: 0.9em;
    font-weight: 300;
    letter-spacing: 0.04em;
    margin-bottom: 0.2em;
    margin-top: 0.1em;
    text-transform: uppercase;
  }

  p {
    font-size: 0.9em;
    line-height: 1.7;
    margin-top: 0px;
    position: relative;

    & + h2 {
      margin-top: 1.7em;
    }

    & + h3 {
      margin-top: 1em;
    }

    & + h4 {
      margin-top: 1.6em;
    }
  }

  ol {
    & + h4 {
      margin-top: 1.2em;
    }
  }

  blockquote {
    margin-left: 2.2em;

    & + h4 {
      margin-top: 1.6em;
    }
  }

  code {
    color: ${colors.accent};
    font-family: ${fonts.main};
    font-size: 0.8em;

    a {
      background-image: none;
      color: ${colors.accent};
    }
  }

  a {
    color: ${colors.main};
    text-decoration: none;
    margin-bottom: -5px;
    padding-bottom: 5px;
    background-image: linear-gradient(
      to right,
      #8cd0c5 100%,
      transparent 100%
    ); /* colors.accent */
    background-position: 0 1.1em;
    background-repeat: no-repeat;
    background-size: 100% 1px;
    transition: all 0.075s ease;

    &:hover {
      background-size: 100% 3px;
      transition: all 0.075s ease;
    }
  }

  img {
    border: 1px solid ${colors.border};
    display: block;
    margin: 1.25em auto;
    max-width: 80%;

    & + h2 {
      margin-top: 2.1875em;
    }
  }
`;

const Content = styled.div`
  margin: 3em 4em;
`;

export default class Index extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      authorized: true,
    };
  }

  getCookie = (cname) => {
    if (typeof window !== `undefined`) {
      var name = cname + "=";
      var decodedCookie = decodeURIComponent(document.cookie);
      var ca = decodedCookie.split(";");
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == " ") {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
    }
    return "";
  };

  componentDidMount() {
    const authorization = this.getCookie("cerberus");
    if (authorization == "true") {
      this.setState({ authorized: true });
    } else {
      this.setState({ authorized: false });
    }
  }

  render() {
    const { data, children } = this.props;
    const { authorized } = this.state;
    return authorized ? (
      <Wrapper id="wrapper">
        <InvisibleForm />
        <Header id="header" class="noprint">
          <Title data={data} />
          <GetUrl Child={Navbar} data={data} />
        </Header>
        <Main id="main">
          <Feedback />
          <Content id="content">{children()}</Content>
          {/* <p>Oeps!</p> */}
        </Main>
      </Wrapper>
    ) : (
      <Authorization />
    );
  }
}

export const query = graphql`
  query NavBarQuery {
    site {
      siteMetadata {
        title
      }
    }
    allMarkdownRemark(
      sort: { fields: [fields___slug], order: ASC }
      filter: { frontmatter: { hidden: { eq: "N" } } }
    ) {
      edges {
        node {
          fields {
            slug
          }
          frontmatter {
            title
            chapter
            type
            _PARENT
            parent
            hidden
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/layouts/index.js